export default __webpack_public_path__ + "./images/bw.087d1df7.png";